export default __webpack_public_path__ + "mini-icon-linux@2x.png";